import React, { Component, Fragment } from 'react';

import {
  Section,
  Paragraph,
  Heading,
  HashtagList,
  Link,
  Share,
  Button,
  Icon,
} from 'components';
import { Contributor, FullwidthImage } from '..';
import { getCloudinaryUrl, toHtml } from 'config/helpers';
import { ICON_TYPES } from 'config';
import MediaTypes from 'config/constants/mediaTypes';
import '../../SingleArticle.scss';

class ArticleContent extends Component {
  renderArticleSections = content => {
    const { allArticles } = this.props;

    return content.map((item, index) => {
      if (index === 0 && item.fullwidthImage) {
        return (
          <FullwidthImage
            image={getCloudinaryUrl(
              item.fullwidthImage.image,
              'f_auto,q_auto,w_1920',
            )}
            alt={item.fullwidthImage.alt}
            comment={item.fullwidthImage.comment}
            key={`image-${index}`}
          />
        );
      }

      if (index === 0) return null;

      if (index === content.length - 1) {
        return (
          <Section
            additionalClass="article-main-container"
            key={`content-${index}`}
          >
            <div className="article__extra-side" />
            <div className="article-content__container">
              {toHtml(item.body, { allArticles })}
            </div>
          </Section>
        );
      }

      return (
        <Fragment key={`section-${index}`}>
          <Section additionalClass="article-main-container">
            <div className="article__extra-side" />
            <div className="article-content__container">
              {toHtml(item.body, { allArticles })}
            </div>
          </Section>
          <FullwidthImage
            image={getCloudinaryUrl(
              item.fullwidthImage.image,
              'f_auto,q_auto,w_1920',
            )}
            comment={item.fullwidthImage.comment}
          />
        </Fragment>
      );
    });
  };

  render() {
    const mediaTypes = [
      MediaTypes.FACEBOOK,
      MediaTypes.LINKEDIN,
      MediaTypes.TWITTER,
    ];
    const { data, windowLocation, contributor, allArticles } = this.props;
    const { cover, lead, title, content, settings, tags } = data;

    return (
      <div className="single-article__container">
        <Section additionalClass="article-section__first">
          <div className="article-title">
            <p className="article-category">{data.settings.category}</p>
            <Heading size={'large'} type={1}>
              {title}
            </Heading>
          </div>
          {lead && (
            <div className="article-subtitle">
              {toHtml(lead, { allArticles })}
            </div>
          )}
        </Section>

        <FullwidthImage
          image={getCloudinaryUrl(cover, 'f_auto,q_auto,w_1920')}
          alt={title}
        />

        <Section additionalClass="article-main-container">
          <Contributor
            avatar={getCloudinaryUrl(contributor.photo, 'f_auto,q_auto,w_100')}
            name={contributor.title}
            job={contributor.job}
          />

          <div className="article-content__container">
            {toHtml(content[0].body, { allArticles })}
          </div>

          <div className="article-aside__container">
            <div className="article-aside__social-media-container">
              <p className="article-aside__social-media-label">
                Share this article:
              </p>
              <Share
                mediaTypes={mediaTypes}
                shareUrl={windowLocation}
                title={title}
              />
            </div>
            <div className="article-aside__contact-container">
              <p className="article-aside__contact-subheading">
                <strong>Contact:</strong>
              </p>
              <p className="article-aside__contact-subheading">
                {"Let's talk about"}
                <br />
                your business
              </p>
              <Link to={'/contact#form'}>
                <Button id={'contact-blog'} color={'yellow'}>
                  contact
                </Button>
              </Link>
            </div>
          </div>
        </Section>

        {this.renderArticleSections(content)}

        <Section spaceless>
          <div className="article__extra-side" />
          <div className="article-content__container">
            <div className="article-content__tags">
              <HashtagList data={tags} />
            </div>
            <div className="article__summary">
              <Paragraph additionalClass={'article__share'}>
                Share this article:
              </Paragraph>
              <Share
                mediaTypes={mediaTypes}
                shareUrl={windowLocation}
                title={title}
              />
            </div>
          </div>
        </Section>
      </div>
    );
  }
}

export default ArticleContent;
